import React, { useRef, useState } from "react";
import { Goal } from "../state/Goal";
import { Alert, Button, Col, Dropdown, FormGroup, ProgressBar } from "react-bootstrap";
import Icon from './Icon';
import {
    faEdit as pencil,
    faArrowUp as arrowUp,
    faArrowDown as arrowDown
} from '@fortawesome/free-solid-svg-icons';
import { ForwardRefEditor } from "./markdown/ForwardRefEditor";
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useData } from "../storage/accessors";

interface GoalWidgetProps {
    goal: Goal;
    index: number;
    roleName?: string;
    onMoveUp?: (uuid: string) => void;
    onMoveDown?: (uuid: string) => void;
    isFirst?: boolean;
    isLast?: boolean;
}

const GoalWidget: React.FC<GoalWidgetProps> = ({ goal, index, roleName, isFirst, isLast, onMoveDown, onMoveUp }) => {
    const { goals } = useData();
    const [edit, setEdit] = useState(goal.description === "");
    const inputRef = useRef(null);
    const save = () => {
        if (!inputRef.current)
            return;
        // @ts-ignore
        goals.save(goal.uuid, { description: inputRef.current?.getMarkdown() || "" });
        setEdit(false);
    };
    return <Alert variant={goal.isDone ? "success" : "light"} dismissible>
        <button type="button" className="btn-close" aria-label="Close alert" onClick={() => {
            if (confirm(`Удалить цель № ${index}?`)) {
                goals.delete(goal.uuid);
            }
        }}></button>
        <div className="mb-2 d-flex align-items-center justify-content-between">
            <div><strong>Цель № {index}: </strong></div>
            <div className="d-flex gap-1">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    disabled={isFirst}
                    onClick={() => onMoveUp?.(goal.uuid)}
                    title="Переместить вверх"
                >
                    <Icon icon={arrowUp} />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    disabled={isLast}
                    onClick={() => onMoveDown?.(goal.uuid)}
                    title="Переместить вниз"
                >
                    <Icon icon={arrowDown} />
                </Button>
            </div>
        </div>
        {!edit && <Markdown remarkPlugins={[remarkGfm]}>{goal.description}</Markdown>}
        <div className="mb-2">{edit && <FormGroup>
            <ForwardRefEditor key={goal.uuid} ref={inputRef} markdown={goal.description || ""} />
        </FormGroup>}
        </div>
        <Col md={3} className="mb-2">
            <ProgressBar style={{ height: 10 }} variant="primary" min={0} max={100} now={goal.ready || 0}></ProgressBar>
        </Col>
        <div className="mb-2">
            {edit && <Button size="sm" onClick={save}>Сохранить</Button>}
            {!edit && <Button size="sm" onClick={() => setEdit(true)}><Icon icon={pencil} /> Редактировать</Button>}
        </div>
        <div className="d-flex flex-row align-items-center mb-2">Готовность <Dropdown className="m-0 ms-1">
            <Dropdown.Toggle variant={goal.ready === 100 ? "success" : "primary"} size="sm">{goal.ready || 0} %</Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 0} onClick={() => goals.save(goal.uuid, { ready: 0, isDone: false })}>0 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 10} onClick={() => goals.save(goal.uuid, { ready: 10, isDone: false })}>10 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 20} onClick={() => goals.save(goal.uuid, { ready: 20, isDone: false })}>20 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 30} onClick={() => goals.save(goal.uuid, { ready: 30, isDone: false })}>30 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 40} onClick={() => goals.save(goal.uuid, { ready: 40, isDone: false })}>40 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 50} onClick={() => goals.save(goal.uuid, { ready: 50, isDone: false })}>50 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 60} onClick={() => goals.save(goal.uuid, { ready: 60, isDone: false })}>60 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 70} onClick={() => goals.save(goal.uuid, { ready: 70, isDone: false })}>70 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 80} onClick={() => goals.save(goal.uuid, { ready: 80, isDone: false })}>80 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 90} onClick={() => goals.save(goal.uuid, { ready: 90, isDone: false })}>90 %</Dropdown.Item>
                <Dropdown.Item as={"button"} active={(goal.ready || 0) === 100} onClick={() => goals.save(goal.uuid, { ready: 100, isDone: true })}>100 %</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
        </div>

    </Alert >
}

export default GoalWidget;